export default {
    SORT_BY_TITLE: "По названию",
    SORT_BY_CREATION: "По дате создания",
    DOCUMENTS: "Документы",
    OBJECTS: "Объекты",
    NAVIGATION: "Проект",
    METHODS: "Методы",
    SCRIPTS: "Скрипты",
    TASKS: "Задачи"
};
